import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';


import DrawPolygonMap from './DrawPolygonMap';
import PlaceGeoSuggest from '../PlaceGeoSuggest/PlaceGeoSuggest';

import messages from '../../../locale/messages';
import { googleMapLoader } from '../../../helpers/googleMapLoader';

import s from './GooglePolygonMap.css';
import bt from '../../../components/commonStyle.css';

class GooglePolygonMap extends React.Component {

  static defaultProps = {
    label: '',
    className: '',
    defaultValue: '',
    containerClassName: ''
  };

  constructor(props) {
    super(props);

    this.state = {
      noResult: false,
      lat: 37.0902,
      lng: -95.7129,
      sw_lat: 9.854550803628602,
      sw_lng: 80.12749270688475,
      ne_lat: 46.588831619427665,
      ne_lng: -120.63917188786621
    };
  }


  async componentDidMount() {
    const { id, initialValue } = this.props;
    this.setState({ value: initialValue });
    await googleMapLoader();
    this.setState({ googleMapsApiLoaded: true });
  }


  handleSelectSuggest = (data) => {
    let viewport, northEast, southWest, sw_lat, sw_lng, ne_lat, ne_lng;

    viewport = data?.viewport;
    northEast = viewport?.high;
    southWest = viewport?.low;
    sw_lat = southWest?.latitude;
    sw_lng = southWest?.longitude;
    ne_lat = northEast?.latitude;
    ne_lng = northEast?.longitude;

    if (data) {
      this.setState({
        lat: data.location && data.location.latitude,
        lng: data.location && data.location.longitude,
        sw_lat,
        sw_lng,
        ne_lat,
        ne_lng
      })
    }
  }

  render() {
    const { label, defaultValue, formName, fieldName, paths,inputClass } = this.props;
    const { formatMessage } = this.props.intl;
    const { lat, lng, googleMapsApiLoaded, sw_lat, sw_lng, ne_lat, ne_lng } = this.state;

    return (
      <div>
        <label className={bt.labelText} >{formatMessage(messages.searchLocation)}</label>
        <PlaceGeoSuggest
          label={label ? label : formatMessage(messages.searchLocation)}
          placeholder={label ? label : formatMessage(messages.searchLocation)}
          initialValue={defaultValue}
          handleSelectSuggest={this.handleSelectSuggest}
          className={inputClass}
        />
        {googleMapsApiLoaded &&
          <div>
            <DrawPolygonMap
              lat={lat}
              lng={lng}
              formName={formName}
              fieldName={fieldName}
              paths={paths}
              sw_lat={sw_lat}
              sw_lng={sw_lng}
              ne_lat={ne_lat}
              ne_lng={ne_lng}
            /> </div>
        }
      </div>
    );
  }
}

export default injectIntl(withStyles(s, bt)(GooglePolygonMap));
